import styled from 'styled-components/macro'

import {
  Field,
  Toggle,
  ToggleGroup,
  type ToggleGroupProps,
  type ToggleGroupChangeEventDetail,
} from '@loadsmart/miranda-react'

import {
  type DerivedShipmentStatus,
  isDerivedShipmentStatus,
} from '../../domain/AgnosticShipmentFilter'

const StyledField = styled(Field)`
  width: 100%;
  min-width: none;
`

const ToggleGroupLayout = styled.div`
  width: 100%;
  min-width: 256px;
  inline-size: auto;

  m-toggle-group {
    width: 100%;
  }
`

type StatusToggleProps = Omit<ToggleGroupProps, 'onChange'> & {
  value?: Array<DerivedShipmentStatus>
  onChange?: (value: Array<DerivedShipmentStatus>) => void
}

export function StatusToggle({ value, onChange, style, ...rest }: StatusToggleProps) {
  function handleChange(event: CustomEvent<ToggleGroupChangeEventDetail>) {
    onChange?.(Array.from(event.detail.value).filter(isDerivedShipmentStatus))
  }

  return (
    <StyledField style={style}>
      <Field.Label id="status-filter-label">Status</Field.Label>
      <ToggleGroupLayout>
        <ToggleGroup
          type="multiple"
          value={value}
          onChange={handleChange}
          {...rest}
          aria-labelledby="status-filter-label"
        >
          <Toggle value="upcoming">Upcoming</Toggle>
          <Toggle value="ongoing">Ongoing</Toggle>
          <Toggle value="past">Past</Toggle>
        </ToggleGroup>
      </ToggleGroupLayout>
    </StyledField>
  )
}
